// src/helpers/time.js

export function timeAgo(dateString) {
    if (!dateString) return "No activity";

    const seconds = Math.floor((Date.now() - new Date(dateString).getTime()) / 1000);

    if (seconds < 60)    return "Just now";
    if (seconds < 3600)  return `${Math.floor(seconds / 60)}m ago`;
    if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
    if (seconds < 2592000) return `${Math.floor(seconds / 86400)}d ago`;

    const months = Math.floor(seconds / 2592000);
    if (months < 12) return `${months}mo ago`;

    return `${Math.floor(months / 12)}y ago`;
}

export function formatDate(dateString, locale = "en-US", options = {}) {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString(locale, {
        year: "numeric",
        month: "short",
        day: "numeric",
        ...options,
    });
}

export function formatDateTime(dateString) {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
}

export function TimeAgo({ date }) {
    return <span>{timeAgo(date)}</span>;
}